:host {
  display: block;
  box-sizing: border-box;
  color: var(--color-surface05);
  font-family: var(--font-family-sans);
  font-size: 14px;
  font-weight: var(--font-rg);
  line-height: calc(var(--space-unit) * 2);
}

:host > div {
  padding: calc(var(--space-unit) * 2);
}

:host > .success {
  background: var(--color-inverse-success);
  fill: var(--color-default-success);
}

:host > .warning {
  background: var(--color-inverse-warning);
  fill: var(--color-default-warning);
}

:host > .error {
  background: var(--color-inverse-error);
  fill: var(--color-default-error);
}
